const createMeasurements = ({
  margin = { top: 20, right: 20, bottom: 40, left: 50 },
  width = 800,
  height = 400,
}) => {
  const innerWidth = width - margin.left - margin.right
  const innerHeight = height - margin.top - margin.bottom
  return { margin, width, height, innerWidth, innerHeight }
}

export default createMeasurements
